var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loader",attrs:{"id":"loading"}},[_c('img',{staticClass:"display-dark",attrs:{"src":"/img/HXWhite.png","alt":"logo_loader"}}),_c('img',{staticClass:"display-light",attrs:{"src":"/img/HXWblack.png","alt":"logo_loader"}})])
}]

export { render, staticRenderFns }